<app-tab-navigation-header title="Device Group" i18n-title="@@device-groupTitle" detail="{{ deviceGroup?.name }}">
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab label="Devices" i18n-label="@@deviceGroupMainTab-devicesLabel" data-automation-id="devices-tab">
			<ng-template matTabContent>
				<app-device-group-devices
					[appBreadcrumbLabel]="deviceGroupDevicesBreadcrumbLabel"
					[mode]="mode"
					[deviceGroupId]="deviceGroupId"
					[deviceGroupName]="deviceGroup?.name ?? ''"
				>
				</app-device-group-devices>
			</ng-template>
		</mat-tab>

		@if (canViewCompanyOrUserAccessTabs()) {
			<mat-tab
				i18n-label="User Access Label|@@deviceGroupMainTab-userAccess"
				label="User Access"
				data-automation-id="user-access-tab"
			>
				<ng-template matTabContent>
					<app-user-access
						[appBreadcrumbLabel]="deviceGroupUsersBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="companyId"
						[deviceGroupId]="deviceGroupId"
						[hasAjaxDevice]="hasAjaxDevice"
						[hasOnlyPDQ]="hasOnlyPDQ"
					></app-user-access>
				</ng-template>
			</mat-tab>
		}

		@if (canViewCompanyOrUserAccessTabs()) {
			<mat-tab
				i18n-label="Company access label|@@deviceGroupMainTab-companyAccess"
				label="Company Access"
				data-automation-id="company-access-tab"
			>
				<ng-template matTabContent>
					<app-company-access
						[appBreadcrumbLabel]="deviceGroupCompaniesBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="companyId"
						[deviceGroupId]="deviceGroupId"
						[hasAjaxDevice]="hasAjaxDevice"
						[hasOnlyPDQ]="hasOnlyPDQ"
					></app-company-access>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessAuditLogs) {
			<mat-tab label="Audit Log" i18n-label="@@deviceGroup-detailsAuditLog" data-automation-id="audit-log-tab">
				<ng-template matTabContent>
					<app-audit-log-list
						[deviceGroupId]="deviceGroupId"
						[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
						[hiddenColumns]="hiddenAuditLogColumns"
					></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
